module.exports = __webpack_public_path__ + "static/media/demoBot.02535655.png";